var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',{domProps:{"innerHTML":_vm._s(_vm.article.title)}}),_c('v-divider'),_c('button-list',{attrs:{"buttons":_vm.buttons},on:{"partica-event":_vm.clicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }